import axios from 'axios'
import store from '../../store'
import router from '../../router'

const requestInterceptor = config => {
    // add the token to the request
    const token = store.getters.user.token
    if (token) {
        config.headers
        .Authorization = `Bearer ${token}`
    }
    return config
}

const requestErrorInterceptor = error => {
    // Do something with request error
    return Promise.reject(error)
}

const responseInterceptor = response => {
    return response
}

const refreshToken = () => {
    return new Promise((resolve, reject) => {
        const refreshConfig = {
            method: 'post',
            url: '/auth/refresh',
            baseURL: process.env.VUE_APP_API_URL,
            headers: {
                Authorization: `Bearer ${store.getters.user.token}`
            }
        }
        axios(refreshConfig).then(resolve).catch(reject)
    })
};

const responseErrorInterceptor = error => {
    if (error.response.status === 401 && !error.config.__isRetryRequest) {
        return refreshToken().then(response => {
            store.commit('UPDATE_TOKEN', { token: response.data.access_token })
            // Update the original request with the new token
            const newRequest = error.config
            newRequest.__isRetryRequest = true;
            newRequest.headers.Authorization = `Bearer ${response.data.access_token}`;
            // Retry the original request with new token
            return axios(newRequest);
        }).catch(error => {
            store.commit('UPDATE_USER', { user: null });
            router.push('/system/login');
            return Promise.reject(error);
        });
    }
    return Promise.reject(error);
};

const axiosInstance = () => {
    const instance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
    })
    instance.interceptors.request.use(requestInterceptor, requestErrorInterceptor)
    instance.interceptors.response.use(responseInterceptor, responseErrorInterceptor)
    return instance
}

export default axiosInstance